import { App as AntdApp } from 'antd';
import dayjs from 'dayjs';
import { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './App.scss';
import urlPath from './constants/urlPath';
import { AppContext } from './contexts/app.context';
import useRouteElements from './hooks/useRouteElements';

import 'dayjs/locale/vi';
import { IResourceFullAccessDetail } from 'src/types/master_data/userResource.type';
import { useInitData } from './hooks/useInitData';

import AnnouncementModal from 'src/pages/v2/Home/AnnouncementModal';
dayjs.locale('vi');

function App() {
  const {
    setResources,
    setUserInfo,
    setIsUserAdmin,
    setResourcePermissionLoading,
    resourcePermissionLoading,
    resources,
    setIsSupportUser,
    isSupportUser
  } = useContext(AppContext);

  const {
    checkAdminQuery,
    // webConfigQuery,
    resourceQuery,
    isSupportUser: _isSupportUser
  } = useInitData({ enabled: true });

  const location = useLocation();
  const isHomePage = location.pathname === urlPath.home.location || location.pathname === urlPath.systemAdmin.location;
  const [isLayoutReady, setIsLayoutReady] = useState(false);

  useEffect(() => {
    if (checkAdminQuery.data?.data !== undefined && !isSupportUser) {
      setIsUserAdmin(checkAdminQuery.data.data);
      localStorage.setItem('isAdmin', JSON.stringify(checkAdminQuery.data.data));
    }
  }, [checkAdminQuery.data, setIsUserAdmin, isSupportUser]);

  // useEffect(() => {
  //   if (webConfigQuery.data?.data) {
  //     console.log(webConfigQuery?.data?.data);

  //     const result = Object.fromEntries(webConfigQuery?.data?.data.map((item) => [item.key, item.value]));
  //     setTheme(result[WebConfigEn.theme] as Theme);
  //     setLanguage(result[WebConfigEn.language] as Language);
  //   }
  // }, [webConfigQuery.data, setTheme, setLanguage]);

  useEffect(() => {
    if (resourceQuery.data?.data && !isSupportUser) {
      let _resourcePermissions: IResourceFullAccessDetail[] = [];
      // Kiểm tra trùng path thì gộp quyền lại
      resourceQuery?.data?.data?.details?.forEach(({ path, permissions, hrTicketCategoryCode, name }) => {
        if (!!path) {
          let pathRoots = path?.split(',');
          pathRoots?.forEach((pathString) => {
            const index = _resourcePermissions?.findIndex((x) => x.path === pathString);
            if (index === -1) {
              _resourcePermissions.push({ path: pathString, permissions: permissions, name, hrTicketCategoryCode });
            } else {
              _resourcePermissions[index] = {
                path: pathString,
                name,
                hrTicketCategoryCode,
                permissions: [...(_resourcePermissions[index] || [])?.permissions, ...permissions]
              };
            }
          });
        }
      });
      setResources(_resourcePermissions);
      // Set User Info
      if (resourceQuery?.data.data.employee) {
        setUserInfo(resourceQuery?.data.data.employee);
        localStorage.setItem('userInfo', JSON.stringify(resourceQuery?.data.data.employee));
      }
    }
  }, [resourceQuery.data, setResources, setUserInfo, isSupportUser]);

  useEffect(() => {
    if (!isSupportUser) {
      if (!resourceQuery) setResourcePermissionLoading(true);
      setResourcePermissionLoading(resourceQuery.isFetching);
    }
  }, [resourceQuery.isFetching, resourceQuery, isSupportUser, setResourcePermissionLoading]);

  useEffect(() => {
    if (_isSupportUser !== undefined) setIsSupportUser(_isSupportUser);
  }, [_isSupportUser, setIsSupportUser]);

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({
          type: 'CHECK_VERSION_AND_CLEAR_CACHE',
          data: {}
        });
      }
    }
  }, []);

  useEffect(() => {
    if (resources) {
      const timer = setTimeout(() => {
        setIsLayoutReady(true);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [resources]);

  const routeElements = useRouteElements(
    resources as IResourceFullAccessDetail[],
    !!resourcePermissionLoading,
    !!isSupportUser
  );

  return (
    <div className={`app-container ${isHomePage ? 'home' : ''} `}>
      <AntdApp>
        {routeElements}
        {isLayoutReady && <AnnouncementModal />}
      </AntdApp>
    </div>
  );
}

export default App;
